import { css as n, styled as t } from "styled-components";
import { CaptionHeavy as s, BodyHeavy as m, Small as c, Caption as g } from "../../../../styles/typography/index.js";
import { Colors as o } from "../../../../styles/colors/index.js";
import { MediaQuery as e } from "../../../../styles/variables.js";
import { Icon as r } from "../../../../components/Icon/index.js";
import { DealImageContainer as x, DealImageSkeletonContainer as h } from "../../DealImage/style.js";
import { DealImage as f } from "../../DealImage/index.js";
import { TextSkeleton as b } from "../../../../components/TextSkeleton/index.js";
import { skeletonFadeAnimation as a } from "../../../../styles/animation.js";
import { SmartLink as u } from "../../../../components/SmartLink/index.js";
import { DealCardCouponStamp as v } from "../components/DealCardCouponStamp/index.js";
import { DealImageBadgeContainer as C } from "../../DealImageBadge/style.js";
import { Theme as i } from "../../../../styles/themes/index.js";
const p = n`
  text-decoration: none;
  border-radius: 16px;
  border: 1px solid rgb(${i.colors.Golf});
  background-color: rgb(${i.colors.Juliet});
`, l = n`
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 12px;
  grid-template-areas:
    'image content'
    'action action';
  padding: 12px;

  @media ${e.SCREEN_MD_UP} {
    padding: 16px 16px 16px 12px;

    grid-template-columns: auto 1fr;
    column-gap: 16px;
    grid-template-rows: 1fr auto;
    grid-template-areas:
      'image content'
      'image action';
  }
`, B = t.div`
  ${l}
  position:relative;
  pointer-events: none;
  z-index: 1;
`, A = t.div`
  border-bottom: 1px solid rgb(${i.colors.Golf});
  padding: 8px 16px;
  overflow: hidden;
`, H = t.div`
  background: transparent;
  border-radius: 0 0 16px 16px;
  overflow: hidden;
`, z = t.div`
  background: transparent;
  border-radius: 0 0 16px 16px;
  overflow: hidden;

  &[data-is-visible='false'] {
    display: none;
  }
`, F = t.div`
  ${p}
  position:relative;
  cursor: pointer;
`, L = t.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
`, J = t.div`
  grid-area: image;
  display: flex;
  pointer-events: all;
  cursor: pointer;
`, y = n`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 102px;
  max-width: 102px;
  max-height: 102px;
  min-height: 102px;

  @media ${e.SCREEN_MD_UP} {
    min-width: 120px;
    max-width: 120px;
    max-height: 120px;
    min-height: 120px;
  }
`, K = t(f)`
  ${y}

  ${x} {
    border: none;

    img {
      object-fit: contain;
    }
  }

  ${C} {
    height: 24px;
  }
`, Q = t.div`
  display: grid;
  grid-template-areas:
    'topContent timestamp'
    'title title';
  align-items: center;

  @media ${e.SCREEN_MD_UP} {
    grid-template-areas: 'topContent timestamp';
    align-items: flex-start;
  }
`, W = t.div`
  margin-bottom: 8px;
  pointer-events: all;
  display: flex;
  align-items: center;
  justify-self: start;
  grid-area: topContent;
`, q = t.div`
  display: flex;
  align-items: center;
  justify-self: end;
  grid-area: timestamp;
  margin-bottom: 8px;

  @media ${e.SCREEN_MD_UP} {
    margin-left: 24px;
    margin-top: 4px;
  }
`, $ = t(u)`
  ${s}
  pointer-events: all;
  text-decoration: none;
  cursor: pointer;
  grid-area: title;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  color: rgb(${i.colors.Alpha});

  &:hover {
    color: rgb(${i.colors.Alpha});
  }

  margin-top: 4px;

  @media ${e.SCREEN_MD_UP} {
    ${m}
    margin-top: 0;
  }
`, S = t(v)`
  margin-right: 8px;
`, w = n`
  a,
  ${S}, ${$} {
    color: rgb(${o.Gray});
  }
`, O = t.div`
  grid-area: content;
  &[aria-disabled='true'] {
    ${w}
  }
`, V = t(r)`
  color: rgb(${o.Gray});
  font-size: 24px;

  &[aria-disabled='true'] {
    color: rgb(${o.Gray});
  }
`;
t(r)`
  font-size: 24px;
  color: ${i.colors.Kilo};
  display: none;

  @media ${e.SCREEN_MD_UP} {
    display: flex;
  }
`;
const X = t.span`
  ${c}
  margin-left: auto;
  padding-bottom: 2px;
  white-space: nowrap;
  color: rgb(${o.Gray});

  @media ${e.SCREEN_MD_UP} {
    ${g}
  }
`, Y = t.div`
  display: flex;
  align-items: center;
  margin-top: 4px;
  @media ${e.SCREEN_MD_UP} {
    margin-top: 12px;
  }
`, Z = t.div`
  pointer-events: all;
  grid-area: action;
  margin-top: 12px;

  > div {
    display: flex;
    align-items: center;
  }
`, tt = t(b)`
  width: 40px;
`, et = t.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 16px;
`, it = t.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
`, ot = t.div`
  ${p}
  ${l}

  ${({ animate: d }) => a({ animate: d, disableBackground: !0 })}
`, nt = t(h)`
  grid-area: image;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 102px;
  max-width: 102px;
  max-height: 102px;
  min-height: 102px;

  @media ${e.SCREEN_MD_UP} {
    min-width: 120px;
    max-width: 120px;
    max-height: 158px;
    min-height: 158px;
  }
`, at = t.div`
  width: 80px;
  height: 32px;
  border-radius: 18px;
  margin-bottom: 4px;
  ${a}

  @media ${e.SCREEN_LG_UP} {
    width: 170px;
  }
`, rt = t.div`
  display: flex;
  justify-content: space-between;
`, pt = t.div`
  display: flex;
  align-items: center;
  gap: 4px;
`, lt = t.div`
  display: flex;
  align-items: center;
  gap: 8px;
`, dt = t.div`
  width: 32px;
  height: 32px;
  border-radius: 18px;
  margin-bottom: 4px;
  ${a({ animate: !0 })}
`;
export {
  Y as Body,
  rt as BottomContainer,
  Z as BottomUserActionsContent,
  L as CardClick,
  z as CashbackContentContainer,
  F as Container,
  B as ContainerGrid,
  ot as ContainerSkeleton,
  O as Content,
  lt as DealActionsRightSkeleton,
  pt as DealAuthorSkeletonContainer,
  at as DealCardButtonSkeleton,
  H as FooterContentContainer,
  A as HeaderContentContainer,
  it as HeaderSkeleton,
  K as Image,
  nt as ImageSkeleton,
  J as ImageWrapper,
  Q as Info,
  X as PublishDate,
  dt as SaveDealButonSkeleton,
  S as Stamp,
  tt as TimeStampSkeleton,
  q as TimestampArea,
  V as TimestampIcon,
  $ as Title,
  et as TitleSkeletonContainer,
  W as TopContent,
  l as containerGridStyle
};
